<button type="button" class="btn btn-primary" (click)="openDialog(confirmationDialog)"
  [attr.data-automation-id]="'cancel-confirmation-btn-cancel'">
  <app-locale localeKey='CANCEL_BTN' localeView='IFRAME'></app-locale>
</button>
<ng-template #confirmationDialog>
  <div class="center" role="dialog" aria-labelledby="cancel-dialog-title">
    <div>
      <h2 id="cancel-dialog-title" class="cancel-confirm-title">
        <app-locale localeKey='CANCEL_CONFIRM_TITLE' localeView='{{localeView}}'></app-locale>
      </h2>
    </div>
    <div class="cancel-confirm-div">
      <app-locale localeKey='CANCEL_CONFIRM_DESCRIPTION' localeView='{{localeView}}'></app-locale>
    </div>
    <br aria-hidden="true">
    <div>
      <mat-dialog-actions>
        <button type="button" class="btn btn-primary btn-group" mat-button (click)="closeDialog()"
          [attr.data-automation-id]="'cancel-confirmation-btn-no'"
          aria-label="No, continue with enrollment">
          <app-locale localeKey='NO' localeView='IFRAME'></app-locale>
        </button>
        <button type="button" class="btn btn-success btn-group" mat-button (click)="goBackToStart()"
          [attr.data-automation-id]="'cancel-confirmation-btn-yes'"
          aria-label="Yes, cancel and return to start">
          <app-locale localeKey='YES' localeView='IFRAME'></app-locale>
        </button>
      </mat-dialog-actions>
    </div>
    <br aria-hidden="true">
  </div>
</ng-template>